import React, { useEffect } from 'react';
import './notification.css';

interface NotificationProps {
  message: string;
  visible: boolean;
  onClose: () => void;
  duration?: number;
  type?: 'success' | 'error';
}

const Notification: React.FC<NotificationProps> = ({ message, visible, onClose, duration = 1000, type }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [visible, onClose, duration]);

  if (!visible) return null;

  return (
    <div className={`notification ${type || ''}`}>
      <div className="notification-content">
        <div className="notification-message">{message}</div>
      </div>
    </div>
  );
};

export default Notification;
